import { isDefined } from "../server/lib/common";

export const versions = {
	v1_0_0: "v1.0.0", // 2022年リリース当初のバージョン
	v2_0_0: "v2.0.0", // 2025年のrelease: 調査票変更したversion
	v3_0_0: "v3.0.0", // 2026年のrelease: アルゴリズム解説書version2
	v3_1_0: "v3.1.0", // 2027年のrelease: 戦略ターゲットの更新バージョン
} as const;

export const latestVersion = versions.v3_1_0;

export const isLatestVersion = (version: string | undefined): boolean => version === latestVersion;

export const isOver3Version = (version: string | undefined): boolean => {
	if (!isDefined(version)) return false;
	const match = version.match(/^v(\d+)\.\d+\.\d+$/);
	if (!match) return false;
	const num = Number(match[1]);
	return num >= 3;
};

export const adCopyVersions = {
	v1_0_0: "v1.0.0", // 2024年リリース当初のバージョン
	v2_0_0: "v2.0.0", //　特別存在しないが、coceptに合わせる
	v3_0_0: "v3.0.0", // 2026年のrelease: アルゴリズム解説書version2
	v3_1_0: "v3.1.0", // 2027年のrelease: 戦略ターゲットの更新バージョン
} as const;

export const adCopyLatestVersion = adCopyVersions.v3_1_0;

export const isAdCopyLatestVersion = (version: string | undefined): boolean => version === adCopyLatestVersion;

export const isAdCopyOver3Version = (version: string | undefined): boolean => {
	if (!isDefined(version)) return false;
	const match = version.match(/^v(\d+)\.\d+\.\d+$/);
	if (!match) return false;
	const num = Number(match[1]);
	return num >= 3;
};
